import React from "react";
import { Box, Button, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { Banner, CopyInputField } from "@rentablo/components";

type Props = {
  token: string;
  onDone: () => void;
};

export const TokenCreatedView = ({ token, onDone }: Props) => {
  const { t } = useTranslation();

  return (
    <Box>
      <Banner
        type="warn"
        text={t("settings.apiAccess.createdModal.warning")}
        mb={6}
      />
      <Typography variant="body3" component="p" mb={2}>
        {t("settings.apiAccess.createdModal.tokenLabel")}
      </Typography>
      <CopyInputField value={token} />
      <Box display="flex" justifyContent="flex-end" mt={11}>
        <Button variant="outlined" onClick={onDone}>
          {t("settings.apiAccess.createdModal.done")}
        </Button>
      </Box>
    </Box>
  );
};
